import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 15000 });

export const wsUrl = (path = "/ws/alerts") => {
  const u = new URL(BACKEND_URL);
  const proto = u.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${u.host}/api${path}`;
};

export const api = {
  bootstrap: () => http.get("/bootstrap").then(r => r.data),
  events: (params) => http.get("/events", { params }).then(r => r.data),
  ackEvent: (id) => http.post(`/events/${id}/ack`).then(r => r.data),
  dismissEvent: (id) => http.post(`/events/${id}/dismiss`).then(r => r.data),
  heatmap: () => http.get("/crowd/heatmap").then(r => r.data),
  throughput: () => http.get("/crowd/throughput").then(r => r.data),
  flows: () => http.get("/crowd/flows").then(r => r.data),
  crowdSummary: () => http.get("/crowd/summary").then(r => r.data),
  incidents: () => http.get("/incidents").then(r => r.data),
  createIncident: (body) => http.post("/incidents", body).then(r => r.data),
  inject: (type) => http.post(`/simulate/inject${type ? `?event_type=${type}` : ""}`).then(r => r.data),
  runScenario: (name) => http.post(`/simulate/scenario`, null, { params: { name } }).then(r => r.data),
  listScenarios: () => http.get(`/simulate/scenarios`).then(r => r.data),
  zone: (id) => http.get(`/zones/${id}`).then(r => r.data),
  match: () => http.get(`/match`).then(r => r.data),
  dashboardOverview: (params) => http.get(`/dashboard/overview`, { params }).then(r => r.data),
  parkingSnapshot: () => http.get(`/parking/snapshot`).then(r => r.data),
  dashboardPanels: (params) => http.get(`/dashboard/panels`, { params }).then(r => r.data),
};
